import { muiTheme } from "@/styles/theme";
import { Box, Typography } from "@mui/material";
import EditLeadType from "@/modules/lead-page/components/lead-info/lead-type/edit-lead-type";
import { useState } from "react";
import {
  LeadReferralOptions,
  LeadReferralOptionsType,
  LeadTypeOption,
} from "@/modules/lead-page/constants";
import { nawyTheme } from "@/styles/nawy-theme/nawy-theme";

const ReassignReferral = () => {
  const [reassignReferralModal, setReassignReferralModal] =
    useState<boolean>(false);

  const [referralOption, setReferralOption] = useState<LeadReferralOptionsType>(
    LeadReferralOptions.CHANGE_CURRENT_LEAD_AND_REFER,
  );

  return (
    <>
      <Box
        sx={{
          display: "flex",
          gap: nawyTheme.nawy.spacing.xs,
          padding: nawyTheme.nawy.spacing.xs,
          alignItems: "center",

          cursor: "pointer",
          ":hover": {
            backgroundColor:
              muiTheme.colorSchemes.light.palette.main.actionDisabled,
          },
        }}
        onClick={() => setReassignReferralModal(true)}
      >
        <Typography
          sx={{
            color: nawyTheme.nawy.colors.semantic.text.primary,
            ...nawyTheme.nawy.typography.english.variants.body.md.regular,
          }}
        >
          Refer Lead (Commission Applies)
        </Typography>
      </Box>
      <EditLeadType
        optionId={LeadTypeOption.ReassignReferral}
        modalOpen={reassignReferralModal}
        setModalOpen={setReassignReferralModal}
        setReferralOption={setReferralOption}
        referralOption={referralOption}
      />
    </>
  );
};

export default ReassignReferral;
